'use client';

import { useTransition } from 'react';
import { AppButton } from '@/components/design/forms';
import { ArrowLeft, Loader2 } from 'lucide-react';
import { useTranslations } from 'next-intl';
import { useRouter, usePathname } from '@/i18n/navigation';
import { useActivityStore } from '@/state/stores/activityStore';
import { getPreviousRegistrationFlowPath } from '@/lib/registrationFlowNavigation';

interface BackButtonProps {
  /** Явный URL; если не задан — предыдущий шаг воронки по текущему пути (не history). */
  to?: string;
  label?: string;
}

export function BackButton({ to, label }: BackButtonProps) {
  const router = useRouter();
  const pathname = usePathname();
  const t = useTranslations('strings.flowNav');
  const orders = useActivityStore((s) => s.orders);
  const latestOrderId = orders.length > 0 ? orders[orders.length - 1].id : null;
  const [isPending, startTransition] = useTransition();

  const handleClick = () => {
    if (isPending) return;
    const path = to ?? getPreviousRegistrationFlowPath(pathname, latestOrderId);
    startTransition(() => {
      router.push(path);
    });
  };

  return (
    <AppButton
      onClick={handleClick}
      disabled={isPending}
      className="inline-flex items-center gap-2 px-4 py-2 text-sm text-fest-subtle-text hover:text-fest-heading transition-colors group disabled:opacity-50 disabled:pointer-events-none"
    >
      {isPending ? (
        <Loader2 className="w-4 h-4 shrink-0 animate-spin" aria-hidden />
      ) : (
        <ArrowLeft className="w-4 h-4 group-hover:-translate-x-1 transition-transform" />
      )}
      <span>{label ?? t('back')}</span>
    </AppButton>
  );
}
